import { render, staticRenderFns } from "./SelectionMode.vue?vue&type=template&id=580beb7a&scoped=true"
import script from "./SelectionMode.vue?vue&type=script&lang=js"
export * from "./SelectionMode.vue?vue&type=script&lang=js"
import style0 from "./SelectionMode.vue?vue&type=style&index=0&id=580beb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580beb7a",
  null
  
)

export default component.exports